import React from "react";
import "./Agreements.css";
import AgreementsHeader from "./AgreementsHeader";

const Agreements = () => {
  const terms = [
    {
      title: "Service Charge",
      description:
        "1 month salary of the candidate will be taken as service charge during the time of registration.",
    },
    {
      title: "Safety and Security",
      description:
        "The client assures safety and security of the candidate. In case of any insecurity or harassment, the contract can be cancelled and no further replacement of services will be provided.",
    },
    {
      title: "Service Replacement",
      description:
        "During the agreement period, if the client is not satisfied with the service, we provide replacement. (Agreement period is 6 months)",
    },
    {
      title: "Non-Refundable Charges",
      description:
        "Registration charges are non-refundable; only the service will be provided.",
    },
    {
      title: "Leave Policy",
      description:
        "Customer has to provide 2 days of leave in a month for the candidate. No compensation will be given for these 2 days of leave.",
    },
    {
      title: "Work Limitations",
      description:
        "No additional work should be assigned to the candidate except what is specified in the agreement.",
    },
    {
      title: "Mistake Handling",
      description:
        "If any mistake is made by the candidate, it should be informed to the management. The client should not take any direct action without informing the management.",
    },
    {
      title: "Salary Payment",
      description:
        "Salary should be paid within the 5th day of every month, with the knowledge of the management.",
    },
    {
      title: "No Personal Relations",
      description:
        "The client should not allow the candidate’s relations to stay with them for any reason. Management will not be responsible for any issues arising due to this.",
    },
    {
      title: "Professional Conduct",
      description:
        "No personal relationship should be maintained with the worker’s family. Professional conduct is mandatory.",
    },
  ];

  return (
    <>
      <AgreementsHeader />
      <div className="termsandconditions container">
        <h2 className="termsandconditions-title text-center">
          Service Agreements
        </h2>
        <p className="termsandconditions-subtitle text-center">
          Please read the following Agreements carefully before availing our
          services.
        </p>
        <ul className="termsandconditions-list">
          {terms.map((term, index) => (
            <li key={index} className="termsandconditions-item">
              <h3 className="termsandconditions-item-title">{term.title}</h3>
              <p className="termsandconditions-item-description">
                {term.description}
              </p>
            </li>
          ))}
        </ul>
        <p className="termsandconditions-footer text-center">
          By using our services, you agree to the terms and conditions stated
          above.
        </p>
      </div>
    </>
  );
};

export default Agreements;
